export default __webpack_public_path__ + "static/media/HungryWalkerScreenshot3.ad2c9b4d.png";